import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol viewBox=\"0 0 128 128\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-money\">\r\n  <circle cx=\"64\" cy=\"64\" r=\"52\" fill=\"currentColor\" opacity=\"0.12\" />\r\n  <circle cx=\"64\" cy=\"64\" r=\"44\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"6\" />\r\n  <text x=\"64\" y=\"76\" text-anchor=\"middle\" font-size=\"42\" font-weight=\"700\" fill=\"currentColor\">�</text>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 31